window.app = new window.Vue({
    el: '#app',
    vuetify: window.vuetify ,
})
